<template>
  <div :style="{
    '--themeColor':themeColor
  }">
    <div class="space-content-info">
      <div class="space-content-info-img">
        <img :src="info.logo ? $imgurl + info.logo : 'https://bigdata.topeti.com/PCRepository/middleground/no-picture.jpg'">
      </div>
      <div class="space-content-info-title">
        <div class="title">{{ info.name }}</div>
        <div class="tag" v-if="isSlogan">{{ info.tip }}</div>
      </div>
      <div class="space-content-info-tag" v-if="isOrgTag">
        {{ info.dept && info.dept.name }}
      </div>
    </div>
    <div class="space-content-data">
      <div class="space-content-data-visitor space-content-data-item" v-if="isVisits">
        <i class="iconfont icondiannao"></i>
        <span>访问量：</span>
        <span>{{info.activationtotalnum || 0}}</span>
      </div>
      <div class="space-content-data-activiy space-content-data-item" v-if="isActivity">
        <i class="iconfont icondiannao"></i>
        <span>活跃度：</span>
        <span>{{info.activationnum || 0}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'indexComp',
  // 组件参数 接收来自父组件的数据
  props: {
    spaceClass: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => ({})
    },
    themeColor: {
      type: String,
      default:'#4e86ff'
    },
    eleAppen: {
      type: Object,
      default: ()=>({})
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {
    // 是否显示组织标签
    isOrgTag () {
      return this.eleAppen.isOrgTag === undefined ? true : this.eleAppen.isOrgTag
    },
    // 标语
    isSlogan () {
      return this.eleAppen.isSlogan === undefined ? true : this.eleAppen.isSlogan
    },
    // 活跃度
    isActivity () {
      return this.eleAppen.isActivity === undefined ? true : this.eleAppen.isActivity
    },
    // 访问量
    isVisits () {
      return this.eleAppen.isVisits === undefined ? true : this.eleAppen.isVisits
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {}
}
</script>

<style scoped lang="scss">
$themeColor: var(--themeColor);
.space-content-data-item {
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
  }

  .iconfont {
    font-size: 18px;
  }
}

.space-content-info-title {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    height: 22px;
    line-height: 22px;
    margin-bottom: 10px;
  }

  .tag {
    font-size: 14px;
    height: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}

.space-content-info-img {
  width: 79px;
  height: 79px;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 100%;
  }
}

.space-content-info-tag {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  color: #FFFFFF;
  font-size: 14px;
  background: $themeColor;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  box-sizing: border-box;

}

.square-1,
.round-1 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 336px;
  height: 160px;
  position: relative;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  box-sizing: border-box;

  .space-content-info {
    flex: 1;
    padding: 0 20px;
    display: flex;
    align-items: center;

    &-tag {
      width: 87px;
      height: 32px;
      border-radius: 0px 0px 0px 8px;
      top: 0;
      right: 0;
    }

    &-title {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  .space-content-data {
    height: 42px;
    border-top: solid 1px #E6EAEE;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;

    &-item {
      display: flex;
      align-items: center;

      .iconfont {
        margin-right: 4px;
      }
    }
  }
}

.round-1 {
  .space-content-info {
    &-img {
      border-radius: 100%;
    }
  }
}

.square-2 {
  width: 217px;
  height: 260px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  .space-content-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 32px;

    &-tag {
      width: 80px;
      height: 32px;
      border-radius: 0px 0px 0px 8px;
      top: 0;
      right: 0;
    }

    &-title {
      display: flex;
      flex-direction: column;
      height: 52px;
      margin-top: 14px;
    }
  }

  .space-content-data {
    height: 69px;
    border-top: solid 1px #E6EAEE;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    justify-content: space-evenly;

    &-item {
      .iconfont {
        margin-right: 12px;
      }
    }
  }
}

.round-2 {
  width: 260px;
  height: 260px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  .space-content-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-tag {
      width: 80px;
      height: 32px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 8px;
    }

    &-img {
      margin-top: 37px;
      margin-bottom: 10px;
    }

    &-title {
      .title {
        margin-bottom: 6px;
      }
    }
  }

  .space-content-data {
    height: 76px;
    width: 100%;
    border-top: solid 1px #E6EAEE;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    justify-content: space-evenly;
  }
}
</style>
